export default "__VITE_ASSET__DUtOvA9I__"